export const APP_ALERT_OUTPUT = 'app_alert_output';
